/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTextField from 'base/components/standalone/TextField';

export const DynamicStandaloneTextField = StandaloneTextField;
export type DynamicStandaloneTextFieldProps = PropsFromComponent<typeof StandaloneTextField>;

export const DynamicStandaloneTextFieldWith = (extras: DynamicStandaloneExtras): typeof StandaloneTextField => {
    return function DynamicStandaloneTextField(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TextField');
        return <StandaloneTextField {...mergeProps({ options: { theme } }, props)} />;
    }
}